import type { CSSProperties } from 'react';
import type { TransitionProps } from '../types';

export const generateTransitionCSSProps = (transitions: Array<TransitionProps>, prefix: string): CSSProperties => {
  // If transitions is not an array, return an empty transition object
  if (!Array.isArray(transitions)) {
    return { transition: undefined };
  }

  const mapValueProp = {};
  const transitionStrings = transitions?.map((transition) => {
    const prop = transition.transitionProperty;
    if (transition.transitionFinalValue && prop) {
      mapValueProp[prop] = transition.transitionFinalValue;
    }

    return [
      transition.transitionProperty,
      transition.transitionDuration,
      transition.transitionTimingFunction,
      transition.transitionBehavior,
    ]
      .filter(Boolean)
      .join(' ');
  });

  if (transitionStrings.length === 0) {
    return { transition: undefined };
  }

  return {
    transition: transitionStrings.join(', '),
    ...Object.entries(mapValueProp).reduce(
      (acc, [key, value]) =>
        Object.assign(acc, {
          [`--${prefix}-${key}`]: value,
        }),
      {} as CSSProperties,
    ),
  };
};
